<template>
  <v-row
    :style="`margin: 0vw 6vw; height: ${
      $vuetify.breakpoint.with > 1661 ? '24vw' : 'max-content'
    }`"
  >
    <notifications
      classes="my-style"
      group="contactSuccessful"
      :closeOnClick="true"
      width="100%"
      position="top"
    ></notifications>
    <v-layout wrap justify-center>
      <v-row>
        <v-col cols="12" sm="3">
          <v-row
            align="center"
            justify="center"
            justify-sm="start"
            style="margin-bottom: 3vw"
            ><v-img
              :max-width="
                $vuetify.breakpoint.lgAndUp
                  ? 236
                  : $vuetify.breakpoint.smAndUp
                  ? 160
                  : 110
              "
              max-height="80"
              src="@/assets/zeda_logo_bottom.svg"
            ></v-img
          ></v-row>
          <v-row
            align="center"
            justify="center"
            justify-sm="start"
            style="margin-bottom: 2vw"
          >
            <v-img
              max-width="18"
              max-height="18"
              src="@/assets/phone_secondary.svg"
            ></v-img
            ><span style="padding-left: 1vw" :style="paragraphOneFont"
              >(941) 792-6564</span
            >
          </v-row>
          <v-row
            align="center"
            justify="center"
            justify-sm="start"
            style="margin-bottom: 2vw"
          >
            <v-img
              max-width="18"
              max-height="18"
              src="@/assets/email_secondary.svg"
            ></v-img
            ><span style="padding-left: 1vw" :style="paragraphOneFont"
              >Info@zeda.ai</span
            >
          </v-row>
          <v-row justify="center" justify-sm="start">
            <v-btn icon class="no-background-hover" elevation="0"
              ><v-img contain src="@/assets/facebook.svg" /></v-btn
            ><v-btn
              icon
              class="no-background-hover"
              style="margin-left: 2vw"
              :style="$vuetify.breakpoint.xsOnly ? 'margin-left: 6vw' : ''"
              elevation="0"
              ><v-img contain src="@/assets/email.svg"
            /></v-btn>
          </v-row>
        </v-col>
        <v-col
          :class="$vuetify.breakpoint.smAndUp ? 'left-border' : ''"
          cols="12"
          sm="9"
          style="padding: 0vw 6vw; position: relative"
        >
          <!-- <div></div> -->
          <span
            :style="
              $vuetify.breakpoint.xsOnly
                ? `padding-left: 4vw; ${headingThreeFont}`
                : `${headingThreeFont}`
            "
            style="margin-left: 0.5vw"
            >Contact with Zeda</span
          >
          <v-form ref="form" lazy-validation>
            <v-container fluid class="pl-lg-3 pl-sm-0 pr-lg-3 pl-sm-0">
              <v-row style="height: 100%">
                <v-col class="mb-0 pb-0">
                  <v-row no-gutters>
                    <v-text-field
                      style="min-width: 160px"
                      :dense="!$vuetify.breakpoint.lgAndUp"
                      outlined
                      label="Name"
                      validate-on-blur
                      v-model="contactForm.name"
                      :rules="rules.nameRules"
                      @blur="rules.nameRules = []"
                    >
                    </v-text-field
                  ></v-row>
                  <v-row no-gutters>
                    <v-text-field
                      style="min-width: 160px"
                      :dense="!$vuetify.breakpoint.lgAndUp"
                      outlined
                      label="Email"
                      validate-on-blur
                      v-model="contactForm.email"
                      :rules="rules.emailRules"
                      @blur="rules.emailRules = []"
                    >
                    </v-text-field>
                  </v-row>
                  <v-row no-gutters dense>
                    <v-text-field
                      style="min-width: 160px"
                      :dense="!$vuetify.breakpoint.lgAndUp"
                      outlined
                      label="Phone"
                      validate-on-blur
                      v-model="contactForm.phone"
                      :rules="rules.phoneRules"
                      @blur="rules.phoneRules = []"
                      hint="Length must be between 7 to 15 characters"
                    >
                    </v-text-field>
                  </v-row>
                </v-col>
                <v-col
                  cols="auto"
                  sm="6"
                  :class="$vuetify.breakpoint.xs ? 'py-0' : ''"
                >
                  <v-row no-gutters>
                    <v-textarea
                      :height="$vuetify.breakpoint.xs ? 100 : ''"
                      auto-grow
                      outlined
                      label="Write your message"
                      validate-on-blur
                      v-model="contactForm.message"
                    >
                    </v-textarea>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-btn
                  class="submit-btn white--text"
                  height="48"
                  width="210"
                  style="
                    text-transform: none;
                    font-weight: bold;
                    background-color: #00857c;
                  "
                  @click="subscribe()"
                  :loading="submitting"
                  elevation="0"
                  >Submit</v-btn
                >
              </v-row>
            </v-container>
          </v-form>
        </v-col></v-row
      >
      <!--<v-flex class="m-bottom-nav__item pt-5" md3 sm12>-->
      <!--<div-->
      <!--class="m-bottom-nav__item__title text-uppercase title pb-3 pr-2 mb-5"-->
      <!--&gt;-->
      <!--Mouchak-->
      <!--</div>-->
      <!--&lt;!&ndash;<div class="m-bottom-nav__item__item mb-3">&ndash;&gt;-->
      <!--&lt;!&ndash;<v-icon class="mr-2 primary&#45;&#45;text">keyboard_arrow_right</v-icon>&ndash;&gt;-->
      <!--&lt;!&ndash;Terms and Conditions&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--<div class="m-bottom-nav__item__item mb-3">-->
      <!--<v-icon class="mr-2 primary&#45;&#45;text">keyboard_arrow_right</v-icon>-->
      <!--User Guide-->
      <!--</div>-->
      <!--<div class="m-bottom-nav__item__item mb-3">-->
      <!--<v-icon class="mr-2 primary&#45;&#45;text">keyboard_arrow_right</v-icon>-->
      <!--Contact us-->
      <!--</div>-->
      <!--&lt;!&ndash;<div class="m-bottom-nav__item__item mb-3">&ndash;&gt;-->
      <!--&lt;!&ndash;<v-icon class="mr-2 primary&#45;&#45;text">keyboard_arrow_right</v-icon>&ndash;&gt;-->
      <!--&lt;!&ndash;Our Team&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--</v-flex>-->

      <!--      <v-flex grow md7 sm12 class="pt-5 m-bottom-nav__item">-->
      <!--        &lt;!&ndash;<div-->
      <!--          class="m-bottom-nav__item__title text-uppercase title pb-3 pr-2 mb-5"-->
      <!--        >-->
      <!--          Contact Us-->
      <!--        </div>&ndash;&gt;-->
      <!--        <v-row justify="center">-->
      <!--          <h2 class="mt-4 mb-8" style="font-size: 40px">Contact Us</h2>-->
      <!--        </v-row>-->
      <!--        <v-row class="mt-5">-->
      <!--          <v-col cols="6">-->
      <!--            <v-layout>-->
      <!--              <v-text-field-->
      <!--                label="Your Name"-->
      <!--                flat-->
      <!--                outlined-->
      <!--                v-model="contactForm.name"-->
      <!--              ></v-text-field>-->
      <!--            </v-layout>-->
      <!--            <v-layout>-->
      <!--              <v-text-field-->
      <!--                label="Your Email ID"-->
      <!--                flat-->
      <!--                outlined-->
      <!--                v-model="contactForm.email"-->
      <!--                @keypress.native.enter="subscribe"-->
      <!--              ></v-text-field>-->
      <!--            </v-layout>-->
      <!--            <v-layout>-->
      <!--              <v-combobox-->
      <!--                outlined-->
      <!--                multiple-->
      <!--                v-model="contactForm.best_times"-->
      <!--                :items="best_times"-->
      <!--                label="Best Time to Reach You"-->
      <!--                max-height="75"-->
      <!--                class="tag-select"-->
      <!--                chips-->
      <!--                deletable-chips-->
      <!--              >-->
      <!--              </v-combobox>-->
      <!--            </v-layout>-->
      <!--            <v-layout>-->
      <!--              <v-select-->
      <!--                label="How Did You Hear About Us?"-->
      <!--                flat-->
      <!--                outlined-->
      <!--                :items="hearing_medium"-->
      <!--                v-model="contactForm.hearing_medium"-->
      <!--                @keypress.native.enter="subscribe"-->
      <!--              ></v-select>-->
      <!--            </v-layout>-->

      <!--            <div class="danger" v-show="errorText !== ''">{{ errorText }}</div>-->
      <!--          </v-col>-->
      <!--          <v-col cols="6">-->
      <!--            <v-layout>-->
      <!--              <v-text-field-->
      <!--                label="Subject"-->
      <!--                flat-->
      <!--                outlined-->
      <!--                v-model="contactForm.subject"-->
      <!--                @keypress.native.enter="subscribe"-->
      <!--              ></v-text-field>-->
      <!--            </v-layout>-->
      <!--            <v-layout>-->
      <!--              <v-textarea-->
      <!--                outlined-->
      <!--                rows="4"-->
      <!--                row-height="20"-->
      <!--                height="228"-->
      <!--                v-model="contactForm.message"-->
      <!--                label="Message body"-->
      <!--              >-->
      <!--              </v-textarea>-->
      <!--            </v-layout>-->
      <!--          </v-col>-->
      <!--          <v-layout class="subscribe-row">-->
      <!--            <v-btn-->
      <!--              color="primary"-->
      <!--              class="sharp-edge mt-2"-->
      <!--              :loading="isLoading"-->
      <!--              depressed-->
      <!--              width="150"-->
      <!--              @click="subscribe()"-->
      <!--              large-->
      <!--              >Submit</v-btn-->
      <!--            >-->
      <!--          </v-layout>-->
      <!--        </v-row>-->
      <!--      </v-flex>-->
      <!--      <v-flex md4 class="hidden-sm-and-down pt-5 m-bottom-nav__item">-->
      <!--        <v-layout justify-center>-->
      <!--          <div-->
      <!--            class="m-bottom-nav__item__title text-uppercase title pb-3 pr-2 mb-2"-->
      <!--          >-->
      <!--            Visit us on Mobile-->
      <!--          </div>-->
      <!--        </v-layout>-->
      <!--        <v-layout justify-center>-->
      <!--          <img src="../assets/qrcode.jpg" alt="header image" />-->
      <!--        </v-layout>-->
      <!--      </v-flex>-->
    </v-layout>
  </v-row>
</template>

<script>
// import $backend from "@/backend";
export default {
  name: "AdContact",
  data() {
    return {
      contactForm: {
        name: "",
        email: "",
        phone: "",
        best_times: [],
        message: "",
        type: "contact",
      },
      rules: {},
      submitting: false,
      best_times: [
        "Morning (8-11AM)",
        "Lunchtime (11AM-1PM)",
        "Afternoon (1-5PM)",
        "Evening (After 5PM)",
      ],
      hearing_medium: ["Google", "Facebook", "Internet", "Others"],
      isLoading: false,
      errorText: "",
    };
  },
  computed: {
    headingThreeFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 20px; line-height: 24px; font-weight: 700; font-family: 'Louis George Café'; color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 24px; line-height: 32px; font-weight: 700; font-family: 'Louis George Café'; color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 24px; line-height: 32px; font-weight: 700; font-family: 'Louis George Café'; color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 32px; line-height: 40px; font-weight: 700; font-family: 'Louis George Café'; color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 32px; line-height: 40px; font-weight: 700; font-family: 'Louis George Café'; color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 32px; line-height: 40px; font-weight: 700; font-family: 'Louis George Café'; color: #475560";
      }
    },
    paragraphOneFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 12px; line-height: 14px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 14px; line-height: 20px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 14px; line-height: 20px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560";
      }
    },
  },

  methods: {
    clearUserData() {
      (this.contactForm.name = ""),
        (this.contactForm.email = ""),
        (this.contactForm.best_times = ""),
        (this.contactForm.hearing_medium = ""),
        (this.contactForm.subject = ""),
        (this.contactForm.phone = ""),
        (this.contactForm.message = "");
    },
    // notification() {
    //   this.$notify({
    //     group: "submissionSuccesful",
    //     type: "success",
    //     title: "Message Sending Successful",
    //     text: "Thank you. Your message has been sent.",
    //     duration: 5000
    //   });
    // },
    async subscribe() {
      this.contactForm.name = this.contactForm.name.trim();
      this.contactForm.email = this.contactForm.email.trim();
      this.rules = {
        nameRules: [(v) => !!v || "Name is required"],
        emailRules: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
        phoneRules: [
          (v) => !!v || "Phone number is required",
          (v) =>
            (v.length >= 7 && v.length <= 15) ||
            "Length must be between 7 and 15 characters",
        ],
      };
      this.$nextTick(() => {
        if (this.$refs.form.validate()) {
          if (this.isValidInput()) {
            try {
              this.submitting = true;
              this.$store.dispatch("submitContactForm", {
                userData: this.contactForm,
              });
              this.$notify({
                group: "contactSuccessful",
                title: "Message Sending Successful",
                text: "Thank you. Your message has been sent.",
                duration: 5000,
              });
            } catch (e) {
              this.error = true;
              this.errorMessage = JSON.stringify(e);
              console.log(e);
            } finally {
              this.submitting = false;
              this.clearUserData();
            }
          }
        }
        //if not valid, errors will be automatically displayed
      });
    },
    isValidInput() {
      let emailRegex = /^\S+@\S+\.\S+$/;
      if (!emailRegex.test(this.contactForm.email)) {
        this.errorText = "Not a valid email";
        return false;
      }
      if (!/^\w[\w -.]+$/.test(this.contactForm.name)) {
        this.errorText =
          "The name can only contain alphanumeric characters, space, - and .";
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
// .v-input__slot {
//   min-height: 44px !important;
//   align-items: center;
// }

.left-border::after {
  top: 0;
  left: 0;
  position: absolute;
  border-left: 1px dashed rgba(0, 133, 124, 0.5);
  width: 33px;
  height: 80%;
  content: "";
}

.tag-select {
  .v-select__selections {
    min-height: 50px !important;
  }
}

.v-chip__content {
  text-overflow: ellipsis;
}

.notificationClass {
  text-decoration-color: white;
  background-color: yellow;
  text-align: center;
}

.my-style {
  .notification-title {
    color: white;
    background-color: deepskyblue;
    text-align: center;
  }

  .notification-content {
    color: white;
    background-color: green;
    text-align: center;
  }
}

.m-bottom-nav__item {
  @media (max-width: 1000px) {
    text-align: center !important;
  }
  .v-btn {
    text-transform: none;
  }
}
.m-bottom-nav__item__title {
  display: inline-block;
  border-bottom: 2px solid #377dff;
}

.m-bottom-nav__item__item {
  text-align: left;
}

.m-bottom-nav__subscribe__text {
  padding: 8px 16px;
  border: 1px solid #377dff;
  width: 100%;
}

.subscribe-row {
  justify-content: center;

  @media (max-width: 1000px) {
    justify-content: center !important;
  }
}
</style>
